import dayjs from "dayjs";
import {
  EventStreamContentType,
  fetchEventSource,
} from "@microsoft/fetch-event-source";
import { message } from "antd";

import { FlowModuleItemType } from "@packages/flow-core/module";
import { FlowNodeTypeEnum } from "@packages/flow-core/module/node/constants";

export type AskAIType = "TEXT" | "FILE" | "IMAGE" | "VOICE" | "VIDEO";

export type GeneratingStatus = "running" | "done";

type StreamFetchProps = {
  url: string;
  data: Record<string, any>;
  onMessage: (data: StreamResponseDataType) => void;
  onClose?: () => void;
  abortCtrl: AbortController;
  credentials?: "omit" | "include";
};
export type StreamResponseDataType = {
  status: GeneratingStatus;
  moduleInfo: FlowModuleItemType & {
    outputMap: Record<string, any>;
    inputMap: Record<string, any>;
  };
  runTime: number;
  dialog?: boolean;
  beginTime: number;
  endTime: number;
};
type StreamResponseType = {
  responseData: StreamResponseDataType[];
};
export const streamFetch = ({
  url,
  data,
  onMessage,
  onClose,
  abortCtrl,
  credentials,
}: StreamFetchProps) => {
  return new Promise<StreamResponseType>((resolve, reject) => {
    (async () => {
      // const timeoutId = setTimeout(() => {
      //   abortCtrl.abort('Time out');
      // }, 300000);

      // response data
      let errMsg = "";
      let responseData: StreamResponseDataType[] = [];
      let finished = false;

      const finish = () => {
        if (errMsg) {
          return failedFinish();
        }
        return resolve({
          responseData,
        });
      };
      const failedFinish = () => {
        finished = true;
        reject({
          message: "响应过程出现异常~",
        });
      };

      // animate response to make it looks smooth
      function animateResponseText() {
        if (finished) return;
        // abort message
        if (abortCtrl.signal.aborted) {
          return finish();
        }

        requestAnimationFrame(animateResponseText);
      }
      // start animation
      animateResponseText();

      try {
        // auto complete variables
        const variables = data?.variables || {};
        variables.cTime = dayjs().format("YYYY-MM-DD HH:mm:ss");

        const requestData = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic c2FiZXIzOnNhYmVyM19zZWNyZXQ=",
          },
          signal: abortCtrl.signal,
          body: JSON.stringify({
            ...data,
          }),
          credentials,
        };

        // send request
        await fetchEventSource(url, {
          ...requestData,
          // headers: {
          //   Authorization: 'Basic c2FiZXIzOnNhYmVyM19zZWNyZXQ=',
          //   'Blade-Auth': `bearer ${Cookies.get('xuanfeng-token')!}`,
          // },
          async onopen(res) {
            // clearTimeout(timeoutId);
            const contentType = res.headers.get("content-type");

            // not stream
            if (contentType?.startsWith("text/plain")) {
              return failedFinish();
            }

            // failed stream
            if (
              !res.ok ||
              !res.headers
                .get("content-type")
                ?.startsWith(EventStreamContentType) ||
              res.status !== 200
            ) {
              try {
                failedFinish();
              } catch {
                const errText = await res.clone().text();
                if (!errText.startsWith("event: error")) {
                  failedFinish();
                }
              }
            }
          },
          onmessage({ data }) {
            try {
              const parseJson = JSON.parse(data);
              responseData.push(parseJson);
              onMessage(parseJson);
              if (
                parseJson.status === "done" &&
                parseJson.moduleInfo.flowType !==
                  FlowNodeTypeEnum.globalVariable
              ) {
                finished = true;
                finish();
                return;
              }
            } catch (error) {}
          },
          onclose() {
            finished = true;
            onClose?.();
          },
          onerror() {
            // clearTimeout(timeoutId);
            // failedFinish();
            // throw new Error('响应过程出错～');
            message.error(`响应过程出错，正在重试~`);
          },
          openWhenHidden: true,
        });
      } catch (err: any) {
        // clearTimeout(timeoutId);

        if (abortCtrl.signal.aborted) {
          finished = true;
          return;
        }
        console.log(err, "fetch error");

        failedFinish();
        return;
      }
    })();
  });
};
